module.exports = __webpack_public_path__ + "static/img/glove_camel.dbfc80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_camel.png
// module id = VhWU
// module chunks = 0